import { Reducer } from 'redux';

import { LegalState } from './types';

const defaultState: LegalState = {
    isLegalLodaing: false,
    legalPosts: [],
};

const reducer: Reducer<LegalState> = (state: LegalState = defaultState, action): LegalState => {
    const { payload } = action;

    switch (action.type) {
        case '@@legal/FETCH_LEGAL_START':
            return { ...state, isLegalLodaing: true };
        case '@@legal/FETCH_LEGAL_SUCCESS':
            return { ...state, isLegalLodaing: false, legalPosts: payload.legalPosts };
        default:
            return state;
    }
};

export { reducer as legal };

export default reducer;
